var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelfGrey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.177,
    height: 28.359,
    viewBox: "0 0 21.177 28.359",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#71778a;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.4,24.541a6.212,6.212,0,1,0-6.213-6.211A6.212,6.212,0,0,0,20.4,24.541Zm3.221,1.749a15.936,15.936,0,0,1-3.221.5,10.751,10.751,0,0,1-3-.611A7.57,7.57,0,0,0,9.807,34.03v6.446H30.984V34.03C30.986,29.645,28,26.291,23.618,26.291Z",
    transform: "translate(-9.807 -12.118)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfGrey);
export default __webpack_public_path__ + "static/media/self_grey.3c6bdea2c9afc751711bb7f44eeba999.svg";
export { ForwardRef as ReactComponent };